MS = window.MS || {};
(function($) {
  MS.hero = {
    selectors: {
      section: '.ms-ps-hero',
      background: '.ms-ps-hero__background',
      withText: '.ms-ps-hero--with-text',
      share: '.ms-ts-hero__share__toggle',
      shareSocial: '.ms-ts-hero__share__social',
      scroller: '.ms-ts-hero__scroll',
      cta: '.ms-ps-hero__cta',
      animated: '.ms-ps-hero--animated',
    },

    init: function() {
      this.$module = $(this.selectors.section);
      this.$wrapper = $(this.selectors.wrapper);
      this.$source = $('img' + this.selectors.background, this.$module);
      this.$background = $('div' + this.selectors.background, this.$module);
      this.$shareToggle = $(this.selectors.share, this.$module);
      this.$shareSocial = $(this.selectors.shareSocial, this.$module);
      this.$scroller = $(this.selectors.scroller, this.$module);
      this.$cta = $(this.selectors.cta, this.$module);

      this.handleAnimation();
      this.handleShare();
    },

    handleAnimation: function() {
      var image = new Image();
      var src = this.$source.attr('src');
      var _this = this;

      if(_this.$module.hasClass(_this.selectors.animated.replace('.',''))) {
        image.onload = function () {
          _this.$module.addClass(_this.selectors.withText.replace('.', ''));
          _this.$background.css('background-image', 'url(' + src + ')');
          _this.$cta.on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function(event) {
            _this.checkScrollerPosition();
          });
        }
        image.src = src;
      } else {
        _this.$background.css('background-image', 'url(' + src + ')');
      }

      window.addEventListener("scroll",  utilities.debounce( function() {
        _this.checkScrollerPosition();
      }, 200));

      _this.$scroller.on('click', function() {
        var $parent = $(this).parents(_this.selectors.section).first();
        // get next module
        var _target = $parent.next().offset().top;
        $("html, body").animate({ scrollTop: _target }, 1000);
      })
    },

    checkScrollerPosition: function() {
      if( $(window).scrollTop() < 300 ) {
        this.$scroller.addClass('is-animate').addClass('is-visible');
      } else {
        this.$scroller.removeClass('is-animate').removeClass('is-visible');
      }
    },

    handleShare: function () {
      this.$shareToggle.on('click', function (e) {
        e.preventDefault();
        var isOpen = $(this).hasClass('is-visible');
        $(this).toggleClass('is-visible', !isOpen);
      });

      this.$shareSocial.on('click', function (e) {
        e.preventDefault();
        var ms_popup;
        var ms_href = $(this).attr('href');

        ms_popup = ($(this).hasClass('pn')) ? window.open(ms_href, 'Share', 'height=600,width=800') : window.open(ms_href, 'Share', 'height=325,width=600');

        if (window.focus) {
          ms_popup.focus();
        }
      });
    }
  };
})(jQuery);
